import React, { useEffect, useState } from 'react';
import {
  Card, CardText, DataTable, Grid, SelectionControl,
  TableBody,
  TableColumn, TableHeader,
  TableRow
} from 'react-md';
import { NotificationManager } from 'react-notifications';
import { BeatLoader } from 'react-spinners';
import ApiRequestService from './ApiRequestService';


//Display the list of Subjects
const SubjectsTable = ({ subjects, onEnableSyncClick }) => {

  return (
    <Card style={{ width: "100%" }} >
      <CardText>
        <DataTable plain>
          <TableHeader>
            <TableRow>
              <TableColumn>Id</TableColumn>
              <TableColumn>Subject</TableColumn>
              <TableColumn>Sync Enabled</TableColumn>
            </TableRow>
          </TableHeader>
          <TableBody>
            {subjects.map((sub, i) => (
              <TableRow key={i}>
                <TableColumn>{sub.subject_id}</TableColumn>
                <TableColumn>{sub.subject_name}</TableColumn>
                <TableColumn>
                  <SelectionControl
                    id={"switch-current-subject" + sub.subject_id}
                    type="switch"
                    name="currentSubject"
                    label={null}
                    checked={sub.enable_sync}
                    onChange={() => onEnableSyncClick(i)}
                  />
                </TableColumn>
              </TableRow>
            ))}
          </TableBody>
        </DataTable>
      </CardText>
    </Card>
  )
};


const SyncEnable = function () {


  const [progress, setProgress] = useState(false);
  const [subjects, setSubjects] = useState([]);
  //const [selectedCategories, setSelectedCategories] = useState([]);

  const getAllSubjects = async () => {
    setProgress(true);
    try {
      let getAllSubjectsResponse = await ApiRequestService({
        method: 'post',
        url: 'getAllSubjects',
      })
      if (getAllSubjectsResponse.data !== undefined && getAllSubjectsResponse.data !== null) {
        if (getAllSubjectsResponse.data.status === 0) {

          if (getAllSubjectsResponse.data.data.subject_names)
            setSubjects([...getAllSubjectsResponse.data.data.subject_names])

        } else if (getAllSubjectsResponse.data.message !== undefined && getAllSubjectsResponse.data.message !== null) {
          NotificationManager.error(getAllSubjectsResponse.data.message, "Error", 5000);
        } else {
          NotificationManager.error("Error When Getting Subjects", "Error", 5000);
        }
      } else {
        NotificationManager.error("Error When Getting Subjects", "Error", 5000);
      }

    } catch (err) {
      NotificationManager.error(err, "Error", 5000);
    } finally {
      setProgress(false);
    }
  }

  const onEnableSyncClick = async(index) => {
    setProgress(true);
    console.debug("I in enable sync click ", index)
    const payload = {
      subject_id: subjects[index].subject_id,
      enable_sync: !subjects[index].enable_sync
    };
    try {
      let enableSyncResponse = await ApiRequestService({
        method: 'post',
        url: '/sync/enableSync',
        data: payload
      })
      if (enableSyncResponse.data.status === 0) {

        let tempArray = [...subjects];
        tempArray[index].enable_sync = payload.enable_sync;
        setSubjects(tempArray)
        setProgress(false);
      } else {
        NotificationManager.error("Error When Getting Subjects", "Error", 5000);
        setProgress(false);
      }


      console.debug("I in enable sync click ", index)
    } catch (err) {
      if (err.status !== undefined && err.status === 403) {
        //User Doesnt Have Access
        NotificationManager.error(
          'Unauthorized',
          'You are not authorized to edit subject',
          5000
        );
      } else {
        NotificationManager.error(err, "Error", 5000);
      }
      
      setProgress(false);
    }
  }

  useEffect(() => {
    getAllSubjects();
  }, []);


  if (progress) {
    return <BeatLoader loading={progress} color={'#bb0000'} size={10} />
  }

  return <Grid>
    <SubjectsTable subjects={subjects} onEnableSyncClick={onEnableSyncClick} />

  </Grid>

}

export default SyncEnable;
